import { Box } from '@chakra-ui/react'
import { TestimonialCard } from '@handlers/signup-v2/components/testimonial-card'
import { motion } from 'framer-motion'
import React from 'react'

const MotionContainer = motion(Box)

export const Testimonial = () => {
  const testimonial = {
    testimonial:
      'Blueprint is the perfect therapy assistant, it facilitates assessments and documentation to allow for less time spent on admin and more time spent focusing on client needs.',
    attribution: '—Sheila Whippo, LPCA',
    image:
      'https://res.cloudinary.com/hellojoy/image/upload/v1748885584/SWhippo_w9qf1g.png',
    imageAlt: 'Sheila Whippo',
    attributionClinic: 'Mindsight Partners'
  }

  const cardWidth = 380
  const spacing = 120
  const initialDelay = 0.7
  const initialDuration = 1

  return (
    <Box
      width="100%"
      overflow="hidden"
      position="relative"
      display="flex"
      justifyContent="center"
    >
      <MotionContainer
        display="flex"
        gap={`${spacing}px`}
        width="fit-content"
        direction="row"
        justify="space-between"
        w="100%"
        initial={{ x: 0 }}
        animate={{
          x: `calc(50% - ${cardWidth / 2}px)`
        }}
        transition={{ duration: 0.6, ease: [0.57, 0.1, 0, 1] }}
      >
        <TestimonialCard
          testimonial={testimonial.testimonial}
          attribution={testimonial.attribution}
          attributionClinic={testimonial.attributionClinic}
          image={testimonial.image}
          imageAlt={testimonial.imageAlt}
          inFocus={true}
          transitionProps={{ duration: initialDuration, delay: initialDelay }}
          childProps={{
            width: `${cardWidth}px`
          }}
        />
      </MotionContainer>
    </Box>
  )
}
